module.exports = __webpack_public_path__ + "img/download_gp-en.3374ea9c.svg";